
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-tools",
      function () {
        return require("private-next-pages/image-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-tools"])
      });
    }
  